module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "confirm-layout"
  }, [_c('div', {
    staticClass: "alert alert-success"
  }, [_vm._v("\n    此藥物總存量: " + _vm._s(_vm.selectedDrugTotalAmount) + " \n  ")]), _vm._v(" "), (_vm.currentProgress === 'action') ? _c('Action', {
    attrs: {
      "inputReadOnly": true,
      "defaultPackContent": 0,
      "checkNum": _vm.currentEvent.number1,
      "defaultNum": _vm.currentEvent.number1,
      "deviceId": _vm.currentEvent.device.id
    },
    on: {
      "setActionData": _vm.getActionData
    }
  }, [_c('h5', [_vm._v("回收退藥盒藥物")])]) : _vm._e(), _vm._v(" "), (_vm.currentProgress === 'finish') ? _c('Loader') : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7094d11c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/RecycleDrugFlow/ConfirmFlow.vue
// module id = 1506
// module chunks = 1